export function cmToIn(cm: number): number {
    return cm / 2.54;
}

export function inToFtIn(inches: number): string {
    const feet = Math.floor(inches / 12);
    const remainingInches = Math.floor(inches % 12);
    return `${feet}' ${remainingInches}"`;
}